import PropTypes from "prop-types"
import React from "react"

const LogContext = ({ context }) => (
	<div>
		<pre>{JSON.stringify(context, null, 4)}</pre>
	</div>
)

LogContext.propTypes = {
	context: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
}

LogContext.defaultProps = {
	context: {}
}

export default LogContext



// WEBPACK FOOTER //
// ./src/containers/logs/components/LogContext.js